<template>
  <div class="mq-tab">

    <slot v-if="$slots.default"></slot>
    <div v-else class="wrapper">
      <svg-icon v-if="icon" :size="iconHeight" :fill="color" :name="icon"></svg-icon>
      <span class="text hide-for-small-only">{{ title }}</span>
    </div>

  </div>
</template>

<script>

import {ViewportDetectionMixin} from '@/components/ViewportDetection'

export default {
  name: 'mq-tab',

  mixins: [ViewportDetectionMixin],

  props: {
    color: {
      type: String
    },
    icon: {
      type: String
    },
    title: {
      type: String
    }
  },

  data () {
    return {
      iconHeight: '70px'
    }
  },

  watch: {
    viewport: {
      immediate: true,
      handler () {
        this.iconHeight = {
          small: '50px',
          medium: '40px',
          mediumlarge: '55px',
          large: '70px',
          xlarge: '70px'
        }[this.viewport]
      }
    }
  }

}
</script>

<style lang="scss">
$height: 80px;
$mediumlarge-height: 56px;
$medium-height: 40px;

.mq-tab {
  cursor: pointer;
  display: block;
  height: $height;
  @include breakpoint(small only) {
    height: 50px;
  }
  @include breakpoint(medium only) {
    height: $medium-height;
  }
  @include breakpoint(mediumlarge only) {
    height: $mediumlarge-height;
  }

  .wrapper {
    padding: 0;
    font-size: rem-calc(23px);
    display: table;
    height: 100%;
    overflow: hidden;
    width: 100%;
    @include breakpoint(small only) {
      width: 100%;
      text-align: center;
    }
    @include breakpoint(medium only) {
      font-size: rem-calc(13px);
    }
    @include breakpoint(mediumlarge only) {
      font-size: rem-calc(15px);
    }

    span.text {
      padding-left: 5px;
      display: table-cell;
      vertical-align: middle;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MqTab.vue